import { render, staticRenderFns } from "./UploadVideo.vue?vue&type=template&id=85ad3e7e&scoped=true&"
import script from "./UploadVideo.vue?vue&type=script&lang=js&"
export * from "./UploadVideo.vue?vue&type=script&lang=js&"
import style0 from "./UploadVideo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UploadVideo.vue?vue&type=style&index=1&id=85ad3e7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ad3e7e",
  null
  
)

export default component.exports